import ProvozovatelPage from "../pages/administration/ProvozovatelPage";
import ZpusobyPlatbyPage from "../pages/administration/ZpusobyPlatbyPage";
import ZpusobyDopravyPage from "../pages/administration/ZpusobyDopravyPage";
import SazbyDphPage from "../pages/administration/SazbyDphPage";
import UkonyPage from "../pages/administration/UkonyPage";
import SouborAtributyPage from "../pages/administration/SouborAtributyPage";
import FakturacniPolozkyPage from "../pages/administration/FakturacniPolozkyPage";
import SpolecnostiPage from "../pages/administration/SpolecnostiPage";
import UzivatelePage from "../pages/administration/UzivatelePage";
import PobockyPage from "../pages/administration/PobockyPage";
import NotifikacePage from "../pages/administration/NotifikacePage";
import * as EnumRole from "../api/gen/cgo/EnumRole";
import {ADMIN_BASE_PATH, SPOLECNOSTI_PATH, UZIVATELE_PATH} from "./routes";
import ParovaniFakturacnichPolozekPage from "../pages/administration/ParovaniFakturacnichPolozekPage";
import DopravciPage from "../pages/administration/DopravciPage";
import AdSyncPage from "../pages/administration/AdSyncPage";
import CenikyPage from "../pages/administration/CenikyPage";

/**
 * Vrátí seznam položek menu administrace ke kterým má uživatel přístup na základě role.
 * @param uzivatel VO uživatele
 * @param t        funkce pro překlad
 * @returns {*}
 */
export const getAdminMenuItems = (uzivatel, t) => {
    switch (uzivatel.role) {
        case EnumRole.ADMIN:
            return [
                {key: 1, title: t('admin.system_operator'), path: `/${ADMIN_BASE_PATH}/provozovatel`, component: ProvozovatelPage},
                {key: 101, title: t('branch_many'), path: `/${ADMIN_BASE_PATH}/pobocky`, subItem: true, component: PobockyPage},
                {key: 102, title: t('admin.billing_items'), path: `/${ADMIN_BASE_PATH}/fakturacnipolozky`, subItem: true, component: FakturacniPolozkyPage},
                {key: 101, title: t('admin.price_list_many'), path: `/${ADMIN_BASE_PATH}/ceniky`, subItem: true, component: CenikyPage},
                {key: 150, title: t('admin.billing_items_pairing'), path: `/${ADMIN_BASE_PATH}/parovani`, subItem: true, component: ParovaniFakturacnichPolozekPage},
                {key: 103, title: t('admin.payment_methods'), path: `/${ADMIN_BASE_PATH}/formauhrady`, subItem: true, component: ZpusobyPlatbyPage},
                {key: 104, title: t('admin.delivery'), path: `/${ADMIN_BASE_PATH}/doprava`, subItem: true, component: ZpusobyDopravyPage},
                {key: 160, title: t('admin.carriers'), path: `/${ADMIN_BASE_PATH}/dopravci`, subItem: true, component: DopravciPage},
                {key: 106, title: t('admin.vat_rates'), path: `/${ADMIN_BASE_PATH}/sazbydph`, subItem: true, component: SazbyDphPage},
                {key: 107, title: t('admin.tasks'), path: `/${ADMIN_BASE_PATH}/ukony`, subItem: true, component: UkonyPage},
                {key: 108, title: t('admin.file_attributes'), path: `/${ADMIN_BASE_PATH}/souboroveatributy`, subItem: true, component: SouborAtributyPage},
                {key: 109, title: t('admin.notifications'), path: `/${ADMIN_BASE_PATH}/notifikace`, subItem: true, component: NotifikacePage},
                {key: 2, title: t('admin.users'), path: `/${ADMIN_BASE_PATH}/${UZIVATELE_PATH}`, component: UzivatelePage},
                {key: 201, title: t('admin.ad_sync'), path: `/${ADMIN_BASE_PATH}/adSync`, subItem: true, component: AdSyncPage},
                {key: 3, title: t('admin.companies'), path: `/${ADMIN_BASE_PATH}/${SPOLECNOSTI_PATH}`, component: SpolecnostiPage},
            ];
        case EnumRole.SPRAVSPOL:
            return [
                {key: 2, title: t('admin.users'), path: `/${ADMIN_BASE_PATH}/${UZIVATELE_PATH}`, component: UzivatelePage},
                {key: 3, title: t('admin.companies'), path: `/${ADMIN_BASE_PATH}/${SPOLECNOSTI_PATH}`, component: SpolecnostiPage},
            ];
        default:
            return [];
    }
};
